import { HydraState } from '@src/constants';
import { Maybe } from '@src/lib/__generated/contentful/sdk';

/**
 * Provide pilot locations for Hydra and this method will return boolean representing if
 * the facility in app storage is within the test group.
 *
 * @param pilotLocations - array from contentful, represents locations that support Hydra API calls
 */
export default function determineHydraSupport(pilotLocations: Maybe<Maybe<string>[]> = [], sessionId = 'N/A'): boolean {
	try {
		// check here for global support of Hydra
		const fullTraffic = pilotLocations?.some((location) => location === 'Full Traffic|ALL') || false;

		if (fullTraffic) {
			return true;
		}

		if (typeof window === 'undefined' || !window.localStorage) {
			throw new Error('Hydra support check is not available in SSR context.');
		}

		const cachedFacility = localStorage.getItem('facilityCode')?.replace(/CC_/g, '')?.replace(/"/g, '');

		if (!cachedFacility) {
			return false;
		}

		return pilotLocations?.some((location) => location?.includes(cachedFacility ?? '')) || false;
	} catch (error) {
		const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
		console.error(`Failed to determine Hydra support: ${errorMessage}`);

		fetch(process.env.APP_PATH + '/api/clear-choice/hydra-status-log/', {
			method: 'POST',
			body: JSON.stringify({
				data: {
					sessionId,
					state: HydraState.OFF,
					messsage: 'FAILED TO DETERMINE HYDRA SUPPORT',
					errorMessage,
				},
			}),
		});
		return false;
	}
}
